import { useLayoutEffect, useRef, FunctionComponent, MutableRefObject } from 'react'

import Header from 'components/layout/Header'

const ResizeHeader: FunctionComponent<ResizeHeaderProps> = ({
  height,
  handleSetFreeTrialHeight,
  headerProps,
  setLayoutHeaderHeight
}: ResizeHeaderProps) => {
  const headerRef: MutableRefObject<HTMLDivElement> = useRef(null)

  useLayoutEffect(() => {
    setLayoutHeaderHeight(headerRef.current.clientHeight)
  }, [])

  useLayoutEffect(() => {
    handleSetFreeTrialHeight(height)
    setLayoutHeaderHeight(height)
  }, [height, handleSetFreeTrialHeight, setLayoutHeaderHeight])

  return (
    <div ref={headerRef}>
      <Header {...{ ...headerProps }} />
    </div>
  )
}

interface ResizeHeaderProps {
  height: number;
  handleSetFreeTrialHeight: (value: number) => void;
  headerProps: any;
  setLayoutHeaderHeight: (value: number) => void;
}

export default ResizeHeader
